import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
// import { googleLogout } from '@react-oauth/google';
import { find } from 'lodash';

import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Badge from '@material-ui/core/Badge';
import Button from '@material-ui/core/Button';
import InfoIcon from '@material-ui/icons/Info';
import AddBoxOutlinedIcon from '@material-ui/icons/AddBoxOutlined';
import AddToHomeScreenIcon from '@material-ui/icons/AddToHomeScreen';
import HomeIcon from '@material-ui/icons/Home';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import SyncAltIcon from '@material-ui/icons/SyncAlt';
import SvgIcon from '@material-ui/core/SvgIcon';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

// import * as ProfileService from '../../../api/profileService';
import * as MessageService from '../../../api/messageService';
import * as MerchantService from '../../../api/merchantService';
import useAuthContext from '../../../hooks/useAuthContext';
import useNavContext from '../../../hooks/useNavContext';
import useMsgContext from '../../../hooks/useMsgContext';
import usePWAContext from '../../../hooks/usePWAContext';

import { ReactComponent as ShareIcon } from '../../../assets/icons/Share.svg';
import { ReactComponent as ScannerIcon } from '../../../assets/icons/Scanner.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    flex: 1,
  },
  list: {
    width: 250,
  },
  fullList: {
    width: 'auto',
  },
  appbar: {
    boxShadow: '0 0 20px #e4e4e4',
    top: 'auto',
    bottom: 0,
  },
  actionContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actionButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(1),
    cursor: 'pointer',
  },
  actionButton: {
    margin: '1.5px 1.5px 0',
    paddingBottom: 0,
  },
  actionIcon: {
    fontSize: 24,
  },
  dialogTextContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  icon: {
    marginLeft: theme.spacing(),
    fontSize: 16,
  },
  activeNavText: {
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.primary.main,
  },
  inactiveNavText: {
    fontWeight: theme.typography.fontWeightRegular,
    color: theme.palette.text.secondary,
  },
}));

export default function AuthLayout({ children }: React.PropsWithChildren<{}>) {
  const [device, setDevice] = useState('');
  const classes = useStyles();
  // const [profile, setProfile] = useState<ProfileService.Profile | null>(null);
  // const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  // const isMenuOpen = Boolean(anchorEl);
  const auth = useAuthContext();
  const nav = useNavContext();
  const msg = useMsgContext();
  const history = useHistory();
  // const deeplink = useDeepLinkContext();
  const pwa = usePWAContext();
  // const initialSetup = useInitContext();
  // const selectedMerchant = useMerchantContext();
  // const selectedStampCard = useStampCardContext();
  // const [isMsgClicked, setIsMsgClicked] = useState(false);
  const [isMoreThanOneMerchant, setIsMoreThanOneMerchant] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [addToHomeScreenDialogOpen, setAddToHomeScreenDialogOpen] =
    useState(false);

  useEffect(() => {
    const detectDevice = () => {
      const userAgent = navigator.userAgent || navigator.vendor;

      // Check for iOS
      if (/iPad|iPhone|iPod/.test(userAgent)) {
        return 'iOS Device';
      }

      // Check for Android
      if (/android/i.test(userAgent)) {
        return 'Android Device';
      }

      // Default to unknown
      return 'Unknown Device';
    };

    if (pwa && isLoading) {
      // pwa.setPWA({
      //   isPWAClicked: pwa.pwa ? pwa.pwa.isPWAClicked : false,
      // });
      setDevice(detectDevice());
    }
  }, [pwa, isLoading]);

  useEffect(() => {
    const fetchMerchantList = async () => {
      if (isLoading && auth && auth.session && auth.session.token.length > 0) {
        try {
          const resMerchantList =
            await MerchantService.listMerchantsByMembership();

          if (resMerchantList && resMerchantList.length > 1) {
            setIsMoreThanOneMerchant(true);
            setIsLoading(false);
          } else {
            setIsMoreThanOneMerchant(false);
            setIsLoading(false);
          }
        } catch (e) {
          console.log("Error - Can't fetch merchants:", e);
          setIsMoreThanOneMerchant(false);
          setIsLoading(false);
        }
      }
    };

    if (isLoading) {
      fetchMerchantList();
    }
  }, [isLoading, auth]);

  useEffect(() => {
    const fetchNewMessage = async () => {
      if (msg && auth && auth.session && auth.session.token.length > 0) {
        try {
          const res = await MessageService.list();

          if (res && msg) {
            const msgUnread = find(res, function (o) {
              return o.status === 'unread';
            });

            if (msgUnread) {
              msg.setMsg({
                isMessagesUnread: true,
              });
            } else {
              msg.setMsg({
                isMessagesUnread: false,
              });
            }
          }
        } catch (e) {
          console.log("Error - Can't fetch messages:", e);
        }
      }
    };

    if (msg) {
      setTimeout(() => {
        if (msg && auth) {
          fetchNewMessage();
        }
      }, 30000);
    }
  }, [msg, auth]);

  // useEffect(() => {
  //   const fetch = async () => {
  //     try {
  //       const res = await ProfileService.get();

  //       setProfile(res);
  //     } catch (e) {
  //       console.log('Error: ', e);
  //     }
  //   };

  //   if (auth && auth.session && auth.session.token.length > 0) {
  //     fetch();
  //   }
  // }, [auth]);

  // const renderMenu = (
  //   <Drawer anchor="top" open={isMenuOpen} onClose={handleMenuClose}>
  //     <List>
  //       <ListItem
  //         button
  //         key="home"
  //         disabled={nav?.nav?.menuNav === 'home'}
  //         onClick={() => {
  //           setIsMsgClicked(false);
  //           handleMenuClose();
  //           history.push('/');
  //           nav?.setNav({
  //             menuNav: 'home',
  //           });
  //         }}
  //       >
  //         <ListItemText primary="HOME" />
  //       </ListItem>
  //       <ListItem
  //         button
  //         key="profile"
  //         onClick={() => {
  //           setIsMsgClicked(false);
  //           handleMenuClose();
  //           history.push('/profile');
  //           nav?.setNav({
  //             menuNav: 'profile',
  //           });
  //         }}
  //         disabled={nav?.nav?.menuNav === 'profile'}
  //       >
  //         <ListItemText primary="YOUR PROFILE" />
  //       </ListItem>
  //       <ListItem
  //         button
  //         key="about"
  //         onClick={() => {
  //           setIsMsgClicked(false);
  //           handleMenuClose();
  //           history.push('/about');
  //           nav?.setNav({
  //             menuNav: 'about',
  //           });
  //         }}
  //         disabled={nav?.nav?.menuNav === 'about'}
  //       >
  //         <ListItemText primary="ABOUT" />
  //       </ListItem>
  //       <ListItem button key="home_screen" onClick={handleAddToHomeScreen}>
  //         <ListItemText primary="ADD TO HOME SCREEN" />
  //       </ListItem>
  //       <ListItem button key="logout" onClick={handleLogOut}>
  //         <ListItemText primary="LOGOUT" />
  //       </ListItem>
  //     </List>
  //   </Drawer>
  // );

  // if (!profile || !msg || !msg.msg) {
  //   return null;
  // }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar position="fixed" color="secondary" className={classes.appbar}>
        <Toolbar className={classes.actionContainer}>
          <div
            className={classes.actionButtonContainer}
            onClick={() => {
              if (nav?.nav?.menuNav !== 'home') {
                history.push('/merchant');
                nav?.setNav({
                  menuNav: 'home',
                });
              }
            }}
          >
            <HomeIcon
              color={nav?.nav?.menuNav === 'home' ? 'primary' : 'disabled'}
            />
            <Typography
              variant="caption"
              className={
                nav?.nav?.menuNav === 'home'
                  ? classes.activeNavText
                  : classes.inactiveNavText
              }
            >
              HOME
            </Typography>
          </div>
          <div
            className={classes.actionButtonContainer}
            onClick={() => {
              history.push('/scan');
              nav?.setNav({
                menuNav: 'scan',
              });
            }}
          >
            <SvgIcon
              component={ScannerIcon}
              className={classes.actionIcon}
              color={nav?.nav?.menuNav === 'scan' ? 'primary' : 'disabled'}
            />
            <Typography
              variant="caption"
              className={
                nav?.nav?.menuNav === 'scan'
                  ? classes.activeNavText
                  : classes.inactiveNavText
              }
            >
              SCAN
            </Typography>
          </div>
          <div
            className={classes.actionButtonContainer}
            onClick={() => {
              // setIsMsgClicked(true);
              history.push('/message');
              nav?.setNav({
                menuNav: 'message',
              });
            }}
          >
            {/* <IconButton
              color={!isMsgClicked ? 'inherit' : 'primary'}
              aria-label="open messages"
              edge="start"
              onClick={() => {
                setIsMsgClicked(true);
                history.push('/message');
                nav?.setNav({
                  menuNav: '',
                });
              }}
              className={classes.actionButton}
            > */}
            {msg && msg.msg && msg.msg.isMessagesUnread ? (
              <Badge overlap="circular" color="primary" variant="dot">
                <EmailOutlinedIcon
                  color={
                    nav?.nav?.menuNav === 'message' ? 'primary' : 'disabled'
                  }
                />
              </Badge>
            ) : (
              <EmailOutlinedIcon
                color={nav?.nav?.menuNav === 'message' ? 'primary' : 'disabled'}
              />
            )}
            {/* </IconButton> */}
            <Typography
              variant="caption"
              className={
                nav?.nav?.menuNav === 'message'
                  ? classes.activeNavText
                  : classes.inactiveNavText
              }
            >
              INBOX
            </Typography>
          </div>
          {isMoreThanOneMerchant && (
            <div
              className={classes.actionButtonContainer}
              onClick={() => {
                history.push('/programs');
                nav?.setNav({
                  menuNav: 'programs',
                });
              }}
            >
              <SyncAltIcon
                color={
                  nav?.nav?.menuNav === 'programs' ? 'primary' : 'disabled'
                }
              />
              <Typography
                variant="caption"
                className={
                  nav?.nav?.menuNav === 'programs'
                    ? classes.activeNavText
                    : classes.inactiveNavText
                }
              >
                PROGRAM{' '}
              </Typography>
            </div>
          )}
          {/* <div
            className={classes.actionButtonContainer}
            onClick={() => {
              setIsMsgClicked(true);
              history.push('/profile');
              nav?.setNav({
                menuNav: '',
              });
            }}
          >
            <AccountCircleIcon color="disabled" />
            <Typography variant="caption">PROFILE</Typography>
          </div> */}
          <div
            className={classes.actionButtonContainer}
            onClick={() => {
              history.push('/more');
              nav?.setNav({
                menuNav: 'more',
              });
            }}
          >
            <MoreHorizIcon
              color={nav?.nav?.menuNav === 'more' ? 'primary' : 'disabled'}
            />
            <Typography
              variant="caption"
              className={
                nav?.nav?.menuNav === 'more'
                  ? classes.activeNavText
                  : classes.inactiveNavText
              }
            >
              MORE
            </Typography>
          </div>
        </Toolbar>
      </AppBar>
      {/* {renderMenu} */}
      {children}
      {/* <MoreOptionDialog
        open={isMenuOpen}
        onClose={handleMenuClose}
        handleLogOut={handleLogOut}
        handleAddToHomeScreen={handleAddToHomeScreen}
        handleAbout={() => {
          handleMenuClose();
          history.push('/about');
          nav?.setNav({
            menuNav: 'about',
          });
        }}
        handleProfile={handleProfile}
      /> */}

      <Dialog
        open={addToHomeScreenDialogOpen}
        onClose={() => setAddToHomeScreenDialogOpen(false)}
      >
        <DialogTitle>
          <InfoIcon style={{ marginRight: 8, verticalAlign: 'middle' }} />
          Add to Homescreen
        </DialogTitle>
        {device === 'iOS Device' && (
          <DialogContent>
            <div className={classes.dialogTextContainer}>
              <Typography variant="body2">
                1. Tap the More button to access options {'(...)'}
              </Typography>
            </div>
            <div className={classes.dialogTextContainer}>
              <Typography variant="body2">2. Tap "Share"</Typography>
              <SvgIcon component={ShareIcon} className={classes.icon} />
            </div>
            <div className={classes.dialogTextContainer}>
              <Typography variant="body2">
                3. Tap "Add to Home Screen"
              </Typography>
              <AddBoxOutlinedIcon className={classes.icon} />
            </div>
          </DialogContent>
        )}
        {device === 'Android Device' && (
          <DialogContent>
            <div className={classes.dialogTextContainer}>
              <Typography variant="body2">
                1. Tap the More button to access options
              </Typography>
              <MoreVertIcon className={classes.icon} />
            </div>
            <div className={classes.dialogTextContainer}>
              <Typography variant="body2">
                2. Tap "Add to Home Screen"
              </Typography>
              <AddToHomeScreenIcon className={classes.icon} />
            </div>
            <div className={classes.dialogTextContainer}>
              <Typography variant="body2">3. Tap "Install"</Typography>
            </div>
          </DialogContent>
        )}
        <DialogActions>
          <Button
            onClick={() => setAddToHomeScreenDialogOpen(false)}
            color="primary"
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
